'use strict';
const angular = require('angular');

/*@ngInject*/
export function TextMessagesService($resource) {
  return $resource('/api/text-messages/:id', {
    name: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/text-messages/type/:type",
      isArray: true
    },
    update: {
      method: 'PUT'
    },
    send: {
      url: "/api/text-messages/send/:id",
      method: 'PUT'
    },
    contact: {
      url: "/api/text-messages/contact",
      method: 'POST'
    }
  });
}


export default angular.module('conduuApp.TextMessagesService', [])
  .factory('TextMessagesService', TextMessagesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/text-messages/text-messages.service.js